import { EnumItemModel } from './ItemModels';

export enum ELanguage {
  English = 1,
  Spanish = 2,
  French = 3
}

export const LanguageEnumItems:
  ReadonlyArray<EnumItemModel<ELanguage>> = [
    { text: 'English', value: ELanguage.English },
    { text: 'French', value: ELanguage.French },
    { text: 'Spanish', value: ELanguage.Spanish }
  ];
